import { Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'app-radio-button-card',
  templateUrl: './radio-button-card.component.html',
  styleUrls: ['./radio-button-card.component.scss'],
})
export class RadioButtonCardComponent {
  @Input() control!: FormControl;
  @Input() name!: string;
  @Input() ariaLabel!: string;
  @Input() value!: string | number;
  @Input() handleSelect: () => void = () => {};
  @Input() isSelected: boolean = false;
  @Input() disabled: boolean = false;
  @Input() centerVertically: boolean = false;

  constructor() {}

  handleSelectWrapper() {
    if (!this.disabled) {
      this.handleSelect();
    }
  }
}
